import { GlobalToken, theme } from 'antd';
import useAntBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { useMemo } from 'react';

const { useToken } = theme;

const getResponsiveMap = (token: GlobalToken) => ({
  xs: `(max-width: ${token.screenXSMax}px)`,
  sm: `(min-width: ${token.screenSM}px)`,
  md: `(min-width: ${token.screenMD}px)`,
  lg: `(min-width: ${token.screenLG}px)`,
  xl: `(min-width: ${token.screenXL}px)`,
  xxl: `(min-width: ${token.screenXXL}px)`,
});

export const useBreakpoint: typeof useAntBreakpoint = refreshOnChange => {
  const { token } = useToken();
  const responsiveMap = getResponsiveMap(token);
  const screens = useAntBreakpoint(refreshOnChange);
  const initialScreens = useMemo(
    () =>
      Object.fromEntries(
        Object.entries(responsiveMap).map(([screen, mediaQuery]) => [screen, window.matchMedia(mediaQuery).matches]),
      ),
    [responsiveMap],
  );

  return Object.keys(screens).length ? screens : initialScreens;
};
